<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<!-- 选项卡 -->
				<div class="title f-bct">
					<p class="a f-ct"><span class="bor"></span>Список индивидуальных кодов</p>
					<p class="r" @click="back()">Вернуться на предыдущую страницу</p>
				</div>
				<!-- 筛选 -->
				<div class="shaixuan f-bct">
					<div class="f-ct">
						<div class="l f-ct">
							<div class="itm1">
								<el-image :src="require('@/static/icon29.png')"></el-image>
								<el-input type="text" v-model="smemberCode" placeholder="Введите код"></el-input>
							</div>
						</div>
						<div class="seachBtn f-ct">
							<div @click="memberCodeList()">Поиск</div>
						</div>
					</div>
					<div class="seachBtn1 f-ct">
						<div @click="hbSubmitN=true,addtype=true,isDefault=1">Добавить код клиента</div>
					</div>
				</div>
				<!-- 列表 -->
				<div class="zw" v-if="!memberCodeArr.length">
					<el-image :src="require('@/static/zw2.png')"></el-image>
					<p class="t1">Нет данных</p>
				</div>
				<div class="maitouList f-ct" v-if="memberCodeArr.length">
					<div class="itm" v-for="(item,index) in memberCodeArr">
						<div class="name f-ct">
							<div class="nub">{{index+1}}</div>
							<!-- <el-image v-if="item.isDefault" :src="require('@/static/icon23.png')"></el-image> -->
							<p>{{item.memberCode}}</p>
						</div>
						<div class="anniuBox f-bct">
							<div class="btnitm t1" @click="mtChange(item)">
								<el-image :src="require('@/static/icon24.png')"></el-image>
								<p>Редактировать</p>
							</div>
							<div class="btnitm t2" @click="mtDel(item)">
								<el-image :src="require('@/static/icon25.png')"></el-image>
								<p>Удалить</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<!-- 弹出框 -->
		<div class="maskBg" v-if="hbSubmitN"></div>
		<div class="subTips" v-if="hbSubmitN">
			<div class="title f-bct">
				<p v-if="addtype">Редактировать код</p>
				<p v-else>Редактировать марку</p>
				<el-image @click="hbSubmitN=false" :src="require('@/static/icon26.png')"></el-image>
			</div>
			<div class="iptBox f-ct">
				<p class="lab">Название кода</p>
				<div class="ipt">
					<el-input type="text" v-model="memberCode" placeholder="Введите название марки"></el-input>
				</div>
			</div>
			<div class="iptBox f-ct">
				<p class="lab">По умолчанию?</p>
				<div class="ipt f-ct">
					<div class="selItm" @click="isDefault = 1">
						<el-image v-if="isDefault==1" :src="require('@/static/icon28.png')"></el-image>
						<el-image v-else :src="require('@/static/icon27.png')"></el-image>
						<p>Да</p>
					</div>
					<div class="selItm" @click="isDefault = 0">
						<el-image v-if="isDefault==0" :src="require('@/static/icon28.png')"></el-image>
						<el-image v-else :src="require('@/static/icon27.png')"></el-image>
						<p>Нет</p>
					</div>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbSubmitN=false">Назад</div>
				<div class="b2" v-if="addtype" @click="memberCodeUpdate">Добавить</div>
				<div class="b2" v-else @click="memberCodeUpdate">Изменить</div>
			</div>
		</div>
		<!-- 删除 -->
		<div class="maskBg" v-if="hbDel"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel">
			<el-image class="cha" @click="hbDel=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удаление марки</div>
			<div class="t1">Вы действительно хотите удалить марку <span>{{mtItem.memberCode}}</span>?</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel=false">Назад</div>
				<div class="b2" @click="memberCodeRemove">Подтвердить</div>
			</div>
		</div>
		<!--  -->
	</div>
</template>
<script>
import { memberCodeRemove,
memberCodeUpdate,
memberCodeAdd,
memberCodeList
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: {
	  'leftBox': () => import('@/components/leftBox.vue')
	},
	data(){
		return {
			memberCodeArr:[],
			smemberCode:'',
			hbSubmitN:false,
			addtype:false,
			hbDel:false,
			memberCode:'',
			isDefault:1,
			mtItem:'',
		}
	},
	mounted() {
		this.memberCodeList()
	},
	methods:{
		// 唛头删除
		mtDel(item){
			this.hbDel = true
			this.mtItem = item
		},
		async memberCodeRemove(){
			const res = await memberCodeRemove({id:this.mtItem.id})
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.hbDel = false
				this.memberCodeList()
			}else{this.Tips(res.msg)}
		},
		// 唛头修改
		mtChange(item){
			if(item){
				this.memberCode = item.memberCode
				this.isDefault = item.isDefault
				this.mtItem = item
			}
			this.hbSubmitN = true
			this.addtype = false
		},
		async memberCodeUpdate(){
			let res;
			var data = {
				memberCode:this.memberCode,
				isDefault:this.isDefault+'',
			}
			console.log(this.isDefault)
			if(this.mtItem){
				data.id = this.mtItem.id
				res = await memberCodeUpdate(data)
			}else{
				res = await memberCodeAdd(data)
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.hbSubmitN = false
				this.memberCodeList()
			}else{this.Tips(res.msg)}
		},
		// 唛头列表
		async memberCodeList(){
			var data = {}
			if(this.smemberCode){data.memberCode = this.smemberCode}
			const res = await memberCodeList(data)
			if(res.code==200){
				this.mtItem = ''
				this.memberCode = ''
				this.isDefault = ''
				this.memberCodeArr = res.rows
			}else{this.Tips(res.msg)}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pcon{
	padding: 0 74px;
	padding-bottom: 46px;
}
.banner{
	width: 100%;
	height: 413px;
	.el-image{
		width: 100%;
		height: 413px;
		border-radius: 18px;
	}
	.dian{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 16px;
		z-index: 2;
		div{
			margin: 0 3px;
			width: 8px;
			height: 8px;
			border-radius: 8px;
			background: #00000033;
			transition:0.3s;
		}
		.a{
			background: #fff;
			width: 14px;
			transition:0.3s;
		}
	}
}
.pageCon{
	margin-top: 32px;
	justify-content: space-between;
	.pageConL{
		width: 530px;
	}
	.pageConR{
		width: calc(100% - 562px);
		.title{
			height: 63px;
			background: #fff;
			border-radius: 12px;
			padding-right: 32px;
			.a{
				.bor{width: 4px;height: 19px;background: #38ABB0;border-radius: 4px;margin-right: 24px;}
				font-size: 18px;
				color: #38ABB0;
			}
			.r{
				font-size: 16px;
				cursor: pointer;
			}
		}
	}
}
.shaixuan{
	// padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	padding-left: 0;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
		.itm1{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			border: 1px solid #DDDDDD;
			border-radius: 4px;
			background: #fff;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
			::v-deep .el-input__inner{
				background: none;
				border: none;
				padding-left: 0;
				width: 240px;
			}
			.el-image{
				display: block;
				width: 16px;
				margin-left: 16px;
				margin-right: 12px;
			}
		}
	}
	.seachBtn{
		// transform: translateX(-12px);
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				// margin-right: 12px;
			}
		}
	}
	.seachBtn1{
		// transform: translateX(-12px);
		div{
			// width: 128px;
			padding: 0 6px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				// margin-right: 12px;
			}
		}
	}
}
.rukuSel{
	.l{
		.el-image{
			width: 20px;
			margin-right: 12px;
		}
		span{
			font-size: 14px;
		}
	}
	.seachBtn{
		p{
			font-size: 14px;
			padding-right: 16px;
		}
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
		}
	}
}
.maitouList{
	width: 1236px;
	// background: pink;
	transform: translateX(-13px);
	.itm{
		width: 386px;
		height: 136px;
		border-radius: 12px;
		background: #fff;
		padding: 24px;
		// margin-right: 26px;
		margin: 0 13px;
		margin-bottom: 24px;
		.name{
			.nub{
				display: inline-block;
				// width: 30px;
				height: 30px;
				// margin-right: 12px;
				background: #38ABB0;
				color: #fff;
				text-align: center;
				line-height: 30px;
				font-size: 18px;
				padding: 0 10px;
				border-radius: 6px;
			}
			.el-image{
				display: inline-block;width: 45px;
				height: 22px;
				margin-left: 12px;
				// margin-right: 8px;
			}
			p{
				display: inline-block;
				font-size: 20px;
				padding-left: 8px;
			}
		}
		.anniuBox{
			margin-top: 20px;
			.btnitm{
				display: flex;
				align-items: center;
				width: 166px;
				height: 40px;
				border-radius: 4px;
				background: #F6F8FB;
				justify-content: center;
				cursor: pointer;
				.el-image{
					width: 14px;
					margin-right: 4px;
				}
				p{
					font-size: 14px;
				}
			}
			.t1{
				p{
					color: #38ABB0;
				}
			}
			.t2{
				p{
					color: #FF4D5A;
				}
			}
		}
		
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
	}
	.t1{
		font-size: 18px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 25px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>